import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';
import { ArticleJsonLd } from '@/components/base/SeoJsonLd';

export default function ClothingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.sbs';
  const pageUrl = `${siteUrl}/kakobuy-spreadsheet-odziez`;

  return (
    <main className="min-h-screen bg-background-50">
      <ArticleJsonLd
        url={pageUrl}
        headline="Kakobuy Spreadsheet Odzież — Kompletny Przewodnik po Ubraniach z Chin"
        description="Bluzy, t-shirty, kurtki, spodnie i wiele więcej. Dowiedz się jak znaleźć najlepsze ubrania przez Kakobuy Spreadsheet i na co zwracać uwagę przy zamawianiu odzieży z chińskich platform."
        imageUrl="https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20minimalist%20flat%20lay%20of%20premium%20casual%20clothing%20pieces%20including%20a%20folded%20oatmeal%20sweater%20a%20pair%20of%20neutral%20trousers%20and%20a%20linen%20shirt%20arranged%20harmoniously%20on%20a%20light%20wooden%20floor%20surface%20soft%20filtered%20daylight%20creating%20a%20calm%20serene%20atmosphere%20Scandinavian%20fashion%20editorial%20aesthetic%20warm%20earthy%20tones%20the%20composition%20is%20clean%20and%20intentional%20with%20generous%20breathing%20space&width=1200&height=600&seq=article-clothing-hero&orientation=landscape"
        datePublished="2026-07-20"
        dateModified="2026-07-21"
        authorName="Kakobuy Polska"
      />
      <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 text-foreground-950 hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">K</span>
              </div>
              <span className="font-semibold text-base tracking-tight">Kakobuy<span className="text-primary-500">Polska</span></span>
            </Link>
            <div className="flex items-center gap-3">
              <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer">
                <i className="ri-arrow-left-line mr-1"></i>Strona główna
              </Link>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                Kakobuy Spreadsheet
              </a>
            </div>
          </div>
        </div>
      </header>

      <article className="py-10 md:py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="mb-8 md:mb-10 rounded-2xl overflow-hidden">
            <img src="https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20minimalist%20flat%20lay%20of%20premium%20casual%20clothing%20pieces%20including%20a%20folded%20oatmeal%20sweater%20a%20pair%20of%20neutral%20trousers%20and%20a%20linen%20shirt%20arranged%20harmoniously%20on%20a%20light%20wooden%20floor%20surface%20soft%20filtered%20daylight%20creating%20a%20calm%20serene%20atmosphere%20Scandinavian%20fashion%20editorial%20aesthetic%20warm%20earthy%20tones%20the%20composition%20is%20clean%20and%20intentional%20with%20generous%20breathing%20space&width=1200&height=600&seq=article-clothing-hero&orientation=landscape" alt="Kakobuy Spreadsheet odzież - ubrania z Chin" title="Kakobuy Spreadsheet Odzież - kompletny przewodnik" className="w-full h-48 md:h-72 object-cover object-top" />
          </div>

          <header className="mb-10 md:mb-14">
            <div className="flex items-center gap-3 text-xs md:text-sm text-foreground-500 mb-4">
              <span className="px-2.5 py-1 bg-primary-50 text-primary-600 rounded-full font-medium">Moda</span>
              <span>•</span>
              <span>9 min czytania</span>
            </div>
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4 md:mb-5">
              Kakobuy Spreadsheet Odzież — Kompletny Przewodnik po Ubraniach z Chin
            </h1>
            <p className="text-sm md:text-lg text-foreground-600 leading-relaxed">
              Bluzy, t-shirty, kurtki, spodnie i wiele więcej. Dowiedz się jak znaleźć najlepsze ubrania przez Kakobuy Spreadsheet i na co zwracać uwagę przy zamawianiu odzieży z chińskich platform.
            </p>
          </header>

          <div className="prose-custom space-y-6 md:space-y-8">
            <section>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">Dlaczego Warto Kupować Odzież przez Kakobuy?</h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                Kategoria odzieżowa w <strong>Kakobuy Spreadsheet</strong> to prawdziwa kopalnia okazji. Od basicowych t-shirtów za kilkanaście złotych, przez wysokiej jakości bluzy i kurtki, aż po designerskie ubrania — wszystko dostępne w cenach znacznie niższych niż w polskich sklepach. Arkusz gromadzi produkty z różnych platform (Taobao, Weidian, 1688), co daje dostęp do ogromnej różnorodności stylów, marek i przedziałów cenowych.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">Rozmiarówka — Na Co Uważać</h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                Największym wyzwaniem przy zakupie ubrań z Chin jest rozmiarówka. Azjatyckie rozmiary są zazwyczaj o 1-2 rozmiary mniejsze niż europejskie. Osoba nosząca w Polsce rozmiar L, w chińskiej rozmiarówce może potrzebować XXL. <strong>Zawsze sprawdzaj tabelę rozmiarów</strong> udostępnianą przez sprzedawcę i mierz swoje ubrania, aby porównać wymiary. Centymetry są Twoim najlepszym przyjacielem — ignoruj oznaczenia literowe (S, M, L), kieruj się konkretnymi wymiarami w cm.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">Rodzaje Materiałów i Jakość</h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                Jakość materiałów w chińskiej odzieży waha się od bardzo słabej do doskonałej. W arkuszu znajdziesz produkty o różnej jakości, dlatego warto zwracać uwagę na skład materiału podawany przez sprzedawcę. Bawełna, len i wełna to bezpieczne wybory. Unikaj ubrań bez podanego składu materiałowego. Zdjęcia QC są tutaj nieocenione — <Link to="/poradnik-bezpieczenstwa-kakobuy" className="text-primary-500 hover:text-primary-600 underline">zawsze je zamawiaj</Link> przed wysyłką do Polski.
              </p>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">Popularne Kategorie Odzieżowe</h2>
              <ul className="list-disc pl-5 space-y-2 text-sm md:text-base text-foreground-700">
                <li><strong>Bluzy i Swetry</strong> — od klasycznych hoodie po oversize'owe swetry. Ceny od 60 CNY.</li>
                <li><strong>T-Shirty</strong> — basicowe i graficzne. Doskonała jakość w cenach 30-80 CNY.</li>
                <li><strong>Kurtki</strong> — puchowe, bomberki, jeansowe. Najlepszy stosunek jakości do ceny.</li>
                <li><strong>Spodnie</strong> — jeansy, joggersy, chinosy. Zwracaj szczególną uwagę na rozmiar!</li>
                <li><strong>Koszulki sportowe</strong> — idealne na siłownię i aktywność fizyczną.</li>
              </ul>
            </section>

            <div className="bg-primary-50 border border-primary-200/50 rounded-2xl p-6 md:p-8 text-center mt-10">
              <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-3">Odkryj Świat Mody z Kakobuy</h3>
              <p className="text-sm md:text-base text-foreground-600 mb-5">Przejrzyj pełną listę ubrań w arkuszu i znajdź swój styl.</p>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="inline-flex items-center px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm md:text-base rounded-xl hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                Otwórz Kakobuy Spreadsheet<i className="ri-arrow-right-up-line ml-2"></i>
              </a>
            </div>

            <div className="border-t border-background-200/60 pt-8 mt-10">
              <h4 className="text-sm font-semibold text-foreground-700 mb-3">Przydatne linki:</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors">← Powrót do strony głównej Kakobuy Polska</Link></li>
                <li><Link to="/kakobuy-spreadsheet-sneakers" className="text-sm text-foreground-500 hover:text-foreground-700 transition-colors">Kakobuy Spreadsheet Sneakers</Link></li>
                <li><Link to="/czym-jest-kakobuy-spreadsheet" className="text-sm text-foreground-500 hover:text-foreground-700 transition-colors">Czym jest Kakobuy Spreadsheet?</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </article>

      <footer className="bg-foreground-950 text-background-50 py-6">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">&copy; {new Date().getFullYear()} KakobuyPolska.sbs — Niezależny przewodnik</p>
          <Link to="/" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">Strona główna</Link>
        </div>
      </footer>
    </main>
  );
}